<template>
<span v-if="showNav">
        <a
            :aria-expanded="otaCollapse"
            class="sidebar-menu-item nav-link"
            data-toggle="collapse"
            @click="otaCollapse=!otaCollapse">
            <template>
                <i class="fa pr-2 fa-rss text-yellow"></i>
                <span class="nav-link-text">OTA <b class="caret"></b></span>
            </template>
        </a>
        <collapse-transition :duration="{enter: 500, leave: 500}">
            <div v-show="otaCollapse" id="collapse-just1" :class="otaCollapse?'show':''" class="collapse collapse-just">
                <ul class="nav nav-sm flex-column">
                    <slot name="title">
                        <router-link
                            test="navPermissions['inventory'].enable"
                            :target="link.target"
                            class="nav-link"
                            href="/ota/inventory"
                            to="/ota/inventory"
                            @click.native="linkClick">
                            <template>
                                <i class="fa fa-folder-open text-green pr-2"></i>
                                <span class="nav-link-text">Inventory</span>
                            </template>
                        </router-link>
                        <router-link
                            v-if="navPermissions['profile'].enable"
                            :target="link.target"
                            class="nav-link"
                            href="/ota/profile/:id"
                            to="/ota/profile/:id"
                            @click.native="linkClick">
                            <template>
                                <i class="fa fa-info text-yellow pr-2"></i>
                                <span class="nav-link-text">Records</span>
                            </template>
                        </router-link>
                        <router-link
                            v-if="navPermissions['activate'].enable"
                            :target="link.target"
                            class="nav-link"
                            href="/ota/activate/:id"
                            to="/ota/activate/:id"
                            @click.native="linkClick">
                            <template>
                              <i class="fa fa-broadcast-tower text-blue" font-scale="1"></i>
                              Activate
                            </template>
                        </router-link>

                        <router-link
                            v-if="isPortalAdminStatus"
                            :target="link.target"
                            class="nav-link"
                            href="/ota/import"
                            to="/ota/import"
                            @click.native="linkClick">
                            <template>
                                <i class="fa fa-upload text-red pr-2"></i>
                                <span class="nav-link-text">Import</span>
                              &nbsp; <i class="fa fa-lock text-gray size-32"></i>
                            </template>
                        </router-link>
                        <router-link
                            v-if="isPortalAdminStatus"
                            :target="link.target"
                            class="nav-link"
                            href="/ota/carrier_admin"
                            to="/ota/carrier_admin"
                            @click.native="linkClick">
                            <template>
                                <i class="fa fa-wrench text-indigo pr-2"></i>
                                <span class="nav-link-text">Carriers</span>
                              &nbsp; <i class="fa fa-lock text-gray size-32"></i>
                            </template>
                        </router-link>
                        <router-link
                            v-if="isPortalAdminStatus"
                            :target="link.target"
                            class="nav-link"
                            href="/ota/user_admin"
                            to="/ota/user_admin"
                            @click.native="linkClick">
                            <template>
                                <i class="fa fa-user text-cyan pr-2"></i>
                                <span class="nav-link-text">Users</span>
                                &nbsp; <i class="fa fa-lock text-gray size-32"></i>
                            </template>
                        </router-link>
                    </slot>
                </ul>
            </div>
        </collapse-transition>  
    </span>
</template>
<script>
import {CollapseTransition} from "vue2-transitions";
import initService from "../../../common/api-services/init-service";

export default {
  name: 'side-ota-group',
  components: {
    CollapseTransition
  },
  data() {
    return {

      isPortalAdminStatus: false,
      isAdminStatus: false,
      groups: [],
      showNav: false,
      otaCollapse: false,
      link: {
        name: '',
        icon: '',
        path: '',
        children: []
      },
      navPermissions: {
        "inventory": {
          enable: false,
          role: ["OTA_ADMIN", "OTA_EDIT", "OTA_READ", "Administrator"]
        },
        "profile": {
          enable: false,
          role: ["OTA_ADMIN", "OTA_EDIT", "OTA_READ", "Administrator"]
        },
        "activate": {
          enable: false,
          role: ["OTA_ADMIN", "OTA_EDIT", "Administrator"]
        },
        "simtool": {
          enable: false,
          role: ["OTA_ADMIN", "OTA_EDIT", "Administrator"]
        },
        "carrier": {
          enable: false,
          role: ["PORTAL_ADMIN"]
        },
        "user": {
          enable: false,
          role: ["PORTAL_ADMIN"]
        },
        "help": {
          enable: false,
          role: ["OTA_ADMIN", "OTA_EDIT", "OTA_READ", "Administrator"]
        }
      }
    }
  },
  mounted() {
    this.isPortalAdminStatus = initService.getPortalAdminRole();
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
    this.groups = initService.getGroups();
    Object.keys(this.navPermissions).map(item => {
      this.groups.map(it => {
        if (this.navPermissions[item].role.includes(it)) {
          this.navPermissions[item].enable = true;
          this.showNav=true;
        }
      });
    });
  },
  methods: {
    linkClick() {
      if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
  }
}
</script>